import { useState } from "react";
import ActionButton from "../components/shared/ActionButton";
import { useOutletContext } from "react-router-dom";

const Workflow = () => {
  const [checkedItems, setCheckedItems] = useState([]);
  const { toggleSidebar } = useOutletContext();

  const toggleCheckbox = (index) => {
    setCheckedItems((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };
  return (
    <div className="flex flex-row w-full min-h-[calc(100vh-100px)]">
      <div className="flex flex-col w-full h-auto gap-2 lg:gap-2">
        {/* Header */}
        <div className="w-full h-auto border-b border-[#0000002B] flex justify-between items-center pb-2">
          <h1 className="text-[13px] font-semibold leading-[100%] text-black font-inter">
            Workflow Tasks
          </h1>

          {/* Menu & Info buttons for small screens */}
          <div className="flex flex-row items-center gap-2 md:hidden">
            <button
              onClick={toggleSidebar}
              className="px-3 py-1 text-[10px] font-medium text-black border border-[#0000002B] rounded-md hover:bg-black-700 transition"
            >
              Menu
            </button>
          </div>
        </div>

        <div className="grid  rounded-[12px] grid-cols-1 shadow-[4px_4px_47.1px_0px_#00000040] gap-4 p-2 md:grid-cols-2 xl:grid-cols-4">
          <div className="bg-[#F9FAFB] rounded-[12px] p-4">
            <div
              className="flex justify-end"
              onClick={() => console.log("Filter Clicked")}
            >
              <ActionButton />
            </div>
            <div className="flex flex-col justify-start pt-4 ">
              <div className="flex flex-col justify-start">
                <span className="text-[14px] pl-1 font-medium font-inter  text-black  py-0.5 rounded">
                  Title
                </span>
                <input
                  type="text"
                  placeholder="Write your title ..."
                  className="text-[13px] rounded-[8px] px-2 bg-white  py-2 pb-2 font-inter text-[#00000073] text-opacity-45 outline-none placeholder:text-[#00000073] placeholder:text-opacity-45"
                />
              </div>
              <div className="flex flex-col justify-start pt-4">
                <span className="text-[14px] pl-1 font-medium font-inter  text-black  py-0.5 rounded">
                  Description
                </span>
                <input
                  type="text"
                  placeholder="Write your description ..."
                  className="text-[13px] rounded-[8px] px-2 bg-white  py-2 pb-2 font-inter text-[#00000073] text-opacity-45 outline-none placeholder:text-[#00000073] placeholder:text-opacity-45"
                />
              </div>
              <div className="flex flex-col justify-start pt-4">
                <span className="text-[14px] pl-1 font-medium font-inter  text-black  py-0.5 rounded">
                  Customer
                </span>
                <select
                  defaultValue=""
                  className="text-[13px] rounded-[8px] px-2 bg-white py-2 font-inter text-[#00000073] text-opacity-45 outline-none"
                >
                  <option value="" disabled>
                    Select Customer
                  </option>
                  <option value="rohit">Rohit Sharma</option>
                  <option value="virat">Virat Kohli</option>
                  <option value="smriti">Smriti Mandhana</option>
                </select>
              </div>{" "}
              <div className="flex flex-col justify-start pt-4">
                <span className="text-[14px] pl-1 font-medium font-inter  text-black  py-0.5 rounded">
                  Priority
                </span>
                <select
                  defaultValue=""
                  className="text-[13px] rounded-[8px] px-2 bg-white py-2 font-inter text-[#00000073] text-opacity-45 outline-none"
                >
                  <option value="" disabled>
                    Select Priority
                  </option>
                  <option value="high">High</option>
                  <option value="medium">Medium</option>
                  <option value="low">Low</option>
                </select>
              </div>
            </div>
          </div>

          {/* Grid 2 - White with border */}
          <div className="bg-white border border-[#00000029] border-opacity-25  rounded-[12px] px-2 py-4">
            <p className="text-sm text-black font-inter ">To Do (4)</p>
            <div className="flex flex-col h-full gap-4 py-3 ">
              <div className=" border-[#00000029] rounded-[12px] h-1/2 border-opacity-25 border ">
                <div className="flex flex-col justify-between h-full ">
                  <div className="flex flex-col ">
                    <div className="flex items-center justify-between w-full gap-3 px-2 mt-2">
                      <img
                        src="/icons/robert.png"
                        alt="icon"
                        className="w-[35px] h-[35px] object-contain"
                      />
                      <div className="flex flex-row items-center gap-1 bg-[#FFE3E3] rounded-lg ">
                        <span className="text-[10px] font-inter  px-2  text-[#FF1F1F]">
                          High Priority
                        </span>
                      </div>
                    </div>
                    <p className="px-2 pt-2 text-[10px] text-black font-inter ">
                      Follow up with Marcus Williams
                    </p>
                    <p className="px-2  text-opacity-45 text-[10px] text-black font-inter ">
                      Resolve order tracking issue #45678
                    </p>
                  </div>

                  <div className="flex flex-row items-center justify-between px-2 py-2 ">
                    <span className="font-inter font-normal text-[11px] leading-[100%] text-opacity-45 tracking-[0%] text-[#00000073]">
                      Due Today
                    </span>

                    <input
                      type="checkbox"
                      checked={checkedItems.includes(0)}
                      onChange={() => toggleCheckbox(0)}
                      className="w-[12px] h-[12px] cursor-pointer accent-black"
                    />
                  </div>
                </div>
              </div>
              <div className=" border-[#00000029] rounded-[12px] h-1/2  border-opacity-25 border ">
                <div className="flex flex-col justify-between h-full ">
                  <div className="flex flex-col ">
                    <div className="flex items-center justify-between w-full gap-3 px-2 mt-2">
                      <img
                        src="/icons/Profile-pic.png"
                        alt="icon"
                        className="w-[35px] h-[35px] object-contain"
                      />
                      <div className="flex  flex-row items-center gap-1 bg-[#FFFEC4] rounded-lg ">
                        <span className="text-[10px] font-inter  px-2  text-[#E4AB00]">
                          Medium Priority
                        </span>
                      </div>
                    </div>
                    <p className="px-2 pt-2 text-[10px] text-black font-inter ">
                      Update Knowledge Base{" "}
                    </p>
                    <p className="px-2  text-opacity-45 text-[10px] text-black font-inter ">
                      Add new FAQs for premium features{" "}
                    </p>
                  </div>

                  <div className="flex flex-row items-center justify-between px-2 py-2 ">
                    <span className="font-inter font-normal text-[11px] leading-[100%] text-opacity-45 tracking-[0%] text-[#00000073]">
                      Due Tomorrow
                    </span>

                    <input
                      type="checkbox"
                      checked={checkedItems.includes(1)}
                      onChange={() => toggleCheckbox(1)}
                      className="w-[12px] h-[12px] cursor-pointer accent-black"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Grid 3 - White with border */}
          <div className="bg-white border border-[#00000029] border-opacity-25  rounded-[12px] px-2 py-4">
            <p className="text-sm text-black font-inter ">In Progress (3)</p>
            <div className="flex flex-col h-full gap-4 py-3 ">
              <div className=" border-[#00000029] rounded-[12px] h-1/2 border-opacity-25 border ">
                <div className="flex flex-col justify-between h-full ">
                  <div className="flex flex-col ">
                    <div className="flex items-center justify-between w-full gap-3 px-2 mt-2">
                      <img
                        src="/icons/jessica.png"
                        alt="icon"
                        className="w-[35px] h-[35px] object-contain"
                      />
                      <div className="flex flex-row items-center gap-1 bg-[#D8E7FF] rounded-lg ">
                        <span className="text-[10px] font-inter  px-2  text-[#3B82F6]">
                          In Review
                        </span>
                      </div>
                    </div>
                    <p className="px-2 pt-2 text-[10px] text-black font-inter ">
                      Prepare Monthly Report{" "}
                    </p>
                    <p className="px-2  text-opacity-45 text-[10px] text-black font-inter ">
                      Customer satisfaction metrics for April{" "}
                    </p>
                  </div>

                  <div className="flex flex-row items-center justify-between px-2 py-2 ">
                    <span className="font-inter font-normal text-[11px] leading-[100%] text-opacity-45 tracking-[0%] text-[#00000073]">
                      2 days left
                    </span>

                    <div className="w-1/2 h-[8px] rounded-[112px] bg-[#D9D9D9]">
                      <div className="h-full w-[80%] bg-[#2F95EE] rounded-[12px]" />
                    </div>
                  </div>
                </div>
              </div>
              <div className=" border-[#00000029] rounded-[12px] h-1/2  border-opacity-25 border ">
                <div className="flex flex-col justify-between h-full ">
                  <div className="flex flex-col ">
                    <div className="flex items-center justify-between w-full gap-3 px-2 mt-2">
                      <img
                        src="/icons/emily.png"
                        alt="icon"
                        className="w-[35px] h-[35px] object-contain"
                      />
                      <div className="flex  flex-row items-center gap-1 bg-[#F1E1FF] rounded-lg ">
                        <span className="text-[10px] font-inter  px-2  text-[#AA59F7]">
                          Testing
                        </span>
                      </div>
                    </div>
                    <p className="px-2 pt-2 text-[10px] text-black font-inter ">
                      Update Knowledge Base{" "}
                    </p>
                    <p className="px-2  text-opacity-45 text-[10px] text-black font-inter ">
                      Add new FAQs for premium features{" "}
                    </p>
                  </div>

                  <div className="flex flex-row items-center justify-between px-2 py-2 ">
                    <span className="font-inter font-normal text-[11px] leading-[100%] text-opacity-45 tracking-[0%] text-[#00000073]">
                      1 week left
                    </span>

                    <div className="w-1/2 h-[8px] rounded-[112px] bg-[#D9D9D9]">
                      <div className="h-full w-[40%] bg-[#2F95EE] rounded-[12px]" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Grid 4 - White with border */}
          <div className="bg-white border border-[#00000029] border-opacity-25  rounded-[12px] px-2 py-4">
            <p className="text-sm text-black font-inter ">Completed (5)</p>
            <div className="flex flex-col h-full gap-4 py-3 ">
              <div className=" border-[#00000029] rounded-[12px] h-1/2 border-opacity-25 border ">
                <div className="flex flex-col justify-between h-full ">
                  <div className="flex flex-col ">
                    <div className="flex items-center justify-between w-full gap-3 px-2 mt-2">
                      <img
                        src="/icons/jessica.png"
                        alt="icon"
                        className="w-[35px] h-[35px] object-contain"
                      />
                      <div className="flex flex-row items-center gap-1 bg-[#E1FFD5] rounded-lg ">
                        <span className="text-[10px] font-inter  px-2  text-[#3FC904]">
                          Completed
                        </span>
                      </div>
                    </div>
                    <p className="px-2 pt-2 text-[10px] text-black font-inter ">
                      Prepare Monthly Report{" "}
                    </p>
                    <p className="px-2  text-opacity-45 text-[10px] text-black font-inter ">
                      Customer satisfaction metrics for April{" "}
                    </p>
                  </div>

                  <div className="flex flex-row items-center justify-between px-2 py-2 ">
                    <span className="font-inter font-normal text-[11px] leading-[100%] text-opacity-45 tracking-[0%] text-[#00000073]">
                      Today
                    </span>

                    <img
                      src={"/icons/double-tick.png"}
                      alt={"add"}
                      className="w-[16px] h-[16px] object-contain"
                    />
                  </div>
                </div>
              </div>
              <div className=" border-[#00000029] rounded-[12px] h-1/2  border-opacity-25 border ">
                <div className="flex flex-col justify-between h-full ">
                  <div className="flex flex-col ">
                    <div className="flex items-center justify-between w-full gap-3 px-2 mt-2">
                      <img
                        src="/icons/emily.png"
                        alt="icon"
                        className="w-[35px] h-[35px] object-contain"
                      />
                      <div className="flex flex-row items-center gap-1 bg-[#E1FFD5] rounded-lg ">
                        <span className="text-[10px] font-inter  px-2  text-[#3FC904]">
                          Completed
                        </span>
                      </div>
                    </div>
                    <p className="px-2 pt-2 text-[10px] text-black font-inter ">
                      Update Knowledge Base{" "}
                    </p>
                    <p className="px-2  text-opacity-45 text-[10px] text-black font-inter ">
                      Add new FAQs for premium features{" "}
                    </p>
                  </div>

                  <div className="flex flex-row items-center justify-between px-2 py-2 ">
                    <span className="font-inter font-normal text-[11px] leading-[100%] text-opacity-45 tracking-[0%] text-[#00000073]">
                      Yesterday
                    </span>

                    <img
                      src={"/icons/double-tick.png"}
                      alt={"add"}
                      className="w-[16px] h-[16px] object-contain"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Workflow;
